import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import * as Ui from './styles';

registerLocale('pt', pt);

export default function InputDate({ onChangeDate, value, placeholder }) {
  const [startDate, setStartDate] = useState(value);

  useEffect(() => {
    setStartDate(value);
  }, [value]);

  function handleChangeDate(date) {
    setStartDate(date);
    if (onChangeDate)onChangeDate(date);
  }
  return (
    <Ui.Container className='custom-input-date'>
      <DatePicker
        placeholderText={placeholder}
        locale="pt"
        dateFormat={'dd/MM/yyyy'}
        selected={startDate}
        onChange={(date) => handleChangeDate(date)}
      />
      <Ui.Calendar />
    </Ui.Container>
  );
}
